export function installLegacyAt(prototype) {
  if (!prototype || typeof prototype.at === "function") return;

  Object.defineProperty(prototype, "at", {
    configurable: true,
    writable: true,
    value(index) {
      const source = Object(this);
      const length = Number(source.length) || 0;
      const integer = Number(index) || 0;
      const resolvedIndex =
        integer < 0 ? length + Math.ceil(integer) : Math.floor(integer);
      if (resolvedIndex < 0 || resolvedIndex >= length) return undefined;
      return source[resolvedIndex];
    },
  });
}

installLegacyAt(Array.prototype);
installLegacyAt(String.prototype);

[
  globalThis.Int8Array,
  globalThis.Uint8Array,
  globalThis.Uint8ClampedArray,
  globalThis.Int16Array,
  globalThis.Uint16Array,
  globalThis.Int32Array,
  globalThis.Uint32Array,
  globalThis.Float32Array,
  globalThis.Float64Array,
  globalThis.BigInt64Array,
  globalThis.BigUint64Array,
]
  .filter(Boolean)
  .forEach((TypedArray) => installLegacyAt(TypedArray.prototype));
